// extracted by mini-css-extract-plugin
export var createdDate = "_la-1";
export var divider = "_la-2";
export var headerDivider = "_la-3";
export var messagesCard = "_la-0";
export var messagesContainer = "_la-7";
export var messagesContainerWrapper = "_la-4";
export var pointerCapturingButtonBoxes = "_la-a";
export var showLeftPanelButton = "_la-9";
export var showMoreButton = "_la-c";
export var showMoreButtonContainer = "_la-b";
export var summaryTitle = "_la-6";
export var systemMessageCardWrapper = "_la-d";
export var topButtons = "_la-8";
export var withPadding = "_la-5";